export default {
  title: '忘记密码',
  subtitle: '请输入在 Global Hub 注册的邮箱账号',
  submitButton: '下一步',
  placeholder: '请输入',
  successTitle: '重置密码邮件已发送',
  successDescription: '我们已向您的邮箱 {email} 发送了一封密码找回邮件，请注意查收邮件，并按照邮件中的提示操作。',
  backToLogin: '返回登录页',
  loading: '发送中...',
  sendFailed: '邮箱账号不存在',
};